import { CHORD_PATH_MISSIONS } from "./chordPathPlan";

const STORAGE_KEY = "bordona-chord-path-progress";
const KNOWN = new Set(CHORD_PATH_MISSIONS.map((m) => m.id));

export type ChordPathProgress = {
  completedMissionIds: string[];
};

export function defaultChordPathProgress(): ChordPathProgress {
  return { completedMissionIds: [] };
}

export function loadChordPathProgress(): ChordPathProgress {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultChordPathProgress();
    const p = JSON.parse(raw) as Partial<ChordPathProgress>;
    const ids = Array.isArray(p.completedMissionIds) ? p.completedMissionIds : [];
    return { completedMissionIds: ids.filter((id) => KNOWN.has(id)) };
  } catch {
    return defaultChordPathProgress();
  }
}

export function saveChordPathProgress(progress: ChordPathProgress): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
}

export function markChordPathMissionComplete(
  progress: ChordPathProgress,
  missionId: string
): ChordPathProgress {
  if (progress.completedMissionIds.includes(missionId)) return progress;
  return {
    completedMissionIds: [...progress.completedMissionIds, missionId],
  };
}
